import {
  required,
  Edit,
  SimpleForm,
  SelectInput,
  ArrayInput,
  TextInput,
  ReferenceInput,
  SimpleFormIterator,
  FormDataConsumer,
} from "react-admin";

import { CustomToolbar } from "../../../utils";
import { onlyNum } from "../../../normalize";

const validateRequired = required();

export const KitEdit = (props) => (
  <Edit title="Editar Kit" {...props}>
    <SimpleForm redirect="list" toolbar={<CustomToolbar />}>
      <TextInput
        placeholder="ex: 1000004"
        label="Flash ID"
        source="externalId"
        validate={validateRequired}
        resettable
        normalize={onlyNum}
      />
      <ReferenceInput
        sort={{ field: "name", order: "ASC" }}
        perPage={999}
        resource="lab"
        source="lab"
        reference="labs"
        validate={validateRequired}
      >
        <SelectInput
          label="Laboratório"
          optionText="name"
          optionValue="id"
          validate={validateRequired}
        />
      </ReferenceInput>

      <FormDataConsumer>
        {({ formData }) => {
          if (!formData.lab) return <div />;

          return (
            <div>
              <ArrayInput
                label="Conteúdo do Kit"
                source="kitsSamples"
                validate={validateRequired}
              >
                <SimpleFormIterator>
                  <ReferenceInput
                    sort={{ field: "name", order: "ASC" }}
                    filter={{ labId: formData.lab }}
                    perPage={999}
                    resource="sample"
                    source="sample.id"
                    reference="samples"
                    validate={validateRequired}
                  >
                    <SelectInput
                      label="Amostra"
                      optionText="name"
                      optionValue="id"
                      validate={validateRequired}
                    />
                  </ReferenceInput>
                  <TextInput
                    placeholder="ex: 23"
                    label="Quantidade"
                    source="sampleQuantity"
                    validate={validateRequired}
                    resettable
                    normalize={onlyNum}
                  />
                </SimpleFormIterator>
              </ArrayInput>
            </div>
          );
        }}
      </FormDataConsumer>
    </SimpleForm>
  </Edit>
);

export default KitEdit;
